import * as React from "react";

import { cn } from "@src/lib/utils/cn";
import { IconProps } from "@src/lib/icons/types";
import Text from "@src/lib/ui/Text";

type Props = {
  Icon?: React.ComponentType<IconProps>;
  children: React.ReactNode;
  className?: string;
};

const Banner: React.FC<Props> = ({ Icon, className, children }) => {
  return (
    <div
      className={cn(
        "flex items-start gap-2 self-stretch rounded-lg bg-status-error-bg p-3 text-status-error-text",
        className,
      )}
    >
      {Icon ? <Icon className="shrink-0" /> : null}
      <Text type="P3" multiline className="min-w-0 flex-1">
        {children}
      </Text>
    </div>
  );
};

export default Banner;
